import React from 'react'
import { Col, Row } from 'reactstrap'

const InfluenzaSymptomsDiagnosis = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 pt-md-5 pt-4 pb-md-4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    SYMPTOMS OF INFLUENZA
                </div>
                <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pt-md-4 pt-3'>
                <Row className=''>
                    <Col xs='6' sm='6' md='3' lg='' className='py-3 flex-center'>
                        <div className=''>
                        <div className='flex-center'>
                            <img src='influenza-testing/Influenza-Testing-icon1.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-16'><center>Coughing</center></div>
                        </div>
                    </Col>

                    <Col xs='6' sm='6' md='3' lg='' className='py-3 flex-center'>
                        <div className=''>
                        <div className='flex-center'>
                            <img src='influenza-testing/Influenza-Testing-icon2.png' alt='' height='auto' width='80px'  />
                        </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-16'><center>Fatigue</center></div>
                        </div>
                    </Col>

                    <Col xs='6' sm='6' md='3' lg='' className='py-3 flex-center'>
                        <div className='pt-md-3'>
                        <div className='flex-center'>
                            <img src='influenza-testing/Influenza-Testing-icon3.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black lh-1-2 fs-ss-16'><center>Cough or sore throat</center></div>
                        </div>
                    </Col>

                    <Col xs='6' sm='6' md='3' lg='' className='py-3 flex-center'>
                        <div className='pt-md-3'>
                        <div className='flex-center'>
                            <img src='influenza-testing/Influenza-Testing-icon4.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black lh-1-2 fs-ss-16'><center>Runny nose and watery eyes</center></div>
                        </div>
                    </Col>

                    <Col xs='6' sm='6' md='3' lg='' className='py-3 flex-center'>
                        <div className='pt-md-3'>
                        <div className='flex-center'>
                            <img src='influenza-testing/Influenza-Testing-icon5.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-16 lh-1-2'><center>Muscle or body aches</center></div>
                        </div>
                    </Col>

                    <Col xs='6' sm='6' md='3' lg='' className='py-3 flex-center'>
                        <div className=''>
                        <div className='flex-center'>
                            <img src='influenza-testing/Influenza-Testing-icon6.png' alt='' height='auto' width='80px'  /></div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-16'><center>Headaches</center></div>
                        </div>
                    </Col>

                    <Col xs='12' sm='12' md='3' lg='' className='py-3 flexcenter '>
                        <div className='pt-md-3'>
                        <div className='flex-center'>
                            <img className='' src='influenza-testing/Influenza-Testing-icon7.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-16 lh-1-2'><center>Vomiting and diarrhea</center></div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='pt-md-5 pt-4'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    DIAGNOSIS
                </div>
                <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pt-md-3 pt-3'>
                <ul className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    <li className=''>Your doctor will perform a physical examination, search for flu-related signs and symptoms, and recommend a flu test to look for influenza viruses.</li> 
                    
                    <li className='py-1'>You may not require a flu test when the virus is common. Your medical professional may make a diagnosis for you based on your symptoms.</li> 
                    
                    <li className=''>Your doctor might advise being tested for influenza to diagnose the flu.</li> 
                </ul>
            </div>
        </div>
    </div>
  )
}

export default InfluenzaSymptomsDiagnosis